
import { computed, defineComponent, ref } from 'vue'

export default defineComponent({
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      required: true
    },
    validator: {
      type: Object,
      required: true
    },
    error: {
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  setup (props) {
    const showError = ref(false)
    // Auto-detect from the Vuelidate rule so callers don't have to duplicate
    // the requiredness that already lives in the validator.
    const isRequired = computed(() => props.required || !!props.validator?.required)
    return { showError, isRequired }
  }
})
